const cardQueryOptions = `{_id, title, desc,categories[]->{title},featuredImage,durationMethod,tags,rating, price}`;

export const categoryDietsQuery = (page = 1, limit = 10) =>
  `*[_type == "diet" && $category in categories[]->title]${cardQueryOptions} | order(_createdAt desc)[${(page - 1) * limit
  }...${page * limit}]`;

export const allDietsQuery = (page) =>
  `*[_type == "diet"] ${cardQueryOptions} | order(_createdAt desc)[${(page - 1) * 10
  }...${page * 10}]`;

export const singleDietQuery = `*[_type == "diet" && _id == $id]{ ...,author->{name,profilePic},categories[]->{title},tags[]->{title}}[0]`;

export const categoriesQuery = (limit = 10) => `*[_type == "category"]{title}[0...${limit}]`;

export const tagsQuery = '*[_type == "tag"]{title}[0...10]';

export const searchQuery = `*[_type == "diet" && title match $query][0...10]${cardQueryOptions}`

export const singleDiet = `*[_type == "diet" && _id match $id][0]${cardQueryOptions}`
